import React from 'react';
import { skipToken } from '@reduxjs/toolkit/query/react';
import { useSelector } from 'react-redux';
import { useGetPartnerHealthStatusQuery } from '../../../api/partnerHealthStatusApi';
import BuildingDevicesTable from '../../../components/BuildingDevicesTable/BuildingDevicesTable';
import { RenderedProps } from '../../../components/collapsibleTable/models';
import { BUILDING_HEALTH_TABLE_LENGTH } from '../../../constants';
import { OrganizationBuildingResponse } from '../../../models/organizationHealthModels';
import { Store } from '../../../reducers';

type PartnerBuildingRowContentProps = RenderedProps & {
    partnerManagedUserGroupId: string;
};

const PartnerBuildingRowContent = ({
    opened,
    id: locationId,
    partnerManagedUserGroupId,
}: PartnerBuildingRowContentProps): React.ReactElement | null => {
    const selectedGroup = useSelector((state: Store) => state.userSettings.selectedGroup);
    const userGroupId = selectedGroup?.id || '';

    const {
        data: buildingData,
        isLoading: loading,
        isFetching: streaming,
        error,
    } = useGetPartnerHealthStatusQuery(
        opened && partnerManagedUserGroupId && userGroupId
            ? {
                  partnerManagedUserGroupId,
                  userGroupId,
                  locationId,
                  limit: BUILDING_HEALTH_TABLE_LENGTH,
                  offset: 0,
              }
            : skipToken
    );

    const buildingResponse = buildingData as OrganizationBuildingResponse | undefined;
    const { devices: data = [], totalDevices: totalData = 0 } = buildingResponse || {};

    if (!opened) {
        return null;
    }

    return (
        <BuildingDevicesTable
            locationId={locationId}
            data={data}
            totalData={totalData}
            loading={loading}
            streaming={streaming}
            error={error}
            tableIdPrefix="partner"
        />
    );
};

export default PartnerBuildingRowContent;
